import React from 'react';
import scaleSize from '../../utils/scale-size';

export default () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={scaleSize(38)}
    height={scaleSize(28)}
    viewBox="0 0 38 28"
  >
    <path
      fill="none"
      fillRule="evenodd"
      stroke="#EE7623"
      strokeWidth="8"
      strokeLinejoin="round"
      strokeLinecap="round"
      d="M34 4L14 24 4 14"
    />
  </svg>
);
